import { Checkbox } from "@mui/material";

export const ACTION_COLUMN_FLEX = "0 0 132px";
export const ACTION_CELL_STYLE = {
  minWidth: "132px",
  display: "flex",
  justifyContent: "flex-end",
  paddingRight: 0,
  overflow: "visible",
};

export const ACTIONS_ROW_STYLE = {
  width: "100%",
  minWidth: "132px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "4px",
  whiteSpace: "nowrap",
  flexWrap: "nowrap",
  overflow: "visible",
};

export const hasActiveSearchQuery = (value = "") => Boolean(value.trim());

export const createField = (text, flex, component = null, extraCellStyle = {}) => ({
  ...(component ? { component } : {}),
  ...(text ? { text } : {}),
  headProps: {
    style: {
      flex,
    },
  },
  cellProps: {
    style: {
      flex,
      ...extraCellStyle,
    },
  },
});

export const createSelectionField = ({ selectionConfig, testIdPrefix, getItemId }) => {
  const SelectAll = () => (
    <Checkbox
      data-testid={`${testIdPrefix}-select-all`}
      checked={selectionConfig?.isAllVisibleSelected}
      indeterminate={selectionConfig?.isSomeVisibleSelected}
      disabled={!selectionConfig?.hasVisibleRows}
      onChange={selectionConfig?.onSelectAllVisible}
      onClick={(event) => event.stopPropagation()}
    />
  );

  const SelectCell = ({ item }) => {
    const itemId = getItemId(item);
    return (
      <Checkbox
        data-testid={`${testIdPrefix}-${itemId}`}
        checked={selectionConfig?.isSelected(itemId)}
        onChange={(event) => {
          event.stopPropagation();
          selectionConfig?.onSelect(itemId);
        }}
        onClick={(event) => event.stopPropagation()}
      />
    );
  };

  return {
    checkbox: {
      component: SelectCell,
      headerComponent: SelectAll,
      headProps: {
        style: {
          flex: "0 1 5%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 5%",
        },
      },
    },
  };
};
